import httpRequest from '../../common/lib/http-request';

// *************************
// PAYMENT SERVICES
// *************************

function validateIBAN(iban) {
    return httpRequest({
        url: '/Payment/iban/validate/' + iban,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function generateRegistrationPayment(payment) {
    return httpRequest({
        url: '/Registration/payment/generate',
        method: 'POST',
        data: payment
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const PaymentService = { generateRegistrationPayment, validateIBAN }

export default PaymentService;